"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const typhonjs_1 = require("@stricahq/typhonjs");
const buildSubAccounts_1 = require("../buildSubAccounts");
const errors_1 = require("@ledgerhq/errors");
const errors_2 = require("../errors");
const js_buildTransaction_1 = require("../js-buildTransaction");
const jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const mockHelpers_1 = require("../../../bridge/mockHelpers");
const receive = (0, mockHelpers_1.makeAccountBridgeReceive)();
const createTransaction = () => {
    return {
        family: "cardano",
        mode: "send",
        amount: new bignumber_js_1.default(100),
        recipient: "",
        poolId: "",
    };
};
const estimateMaxSpendable = ({ account }) => {
    return account.balance;
};
const isValidAddress = (address) => {
    return address.length > 0;
};
const getTransactionStatus = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const errors = { fees: new Error(), recipient: new Error(), amount: new Error() };
    const warnings = {};
    const estimatedFees = transaction.fees || new bignumber_js_1.default(0);
    const tokenAccount = transaction.subAccountId && account.subAccounts
        ? account.subAccounts.find(a => {
            return a.id === transaction.subAccountId;
        })
        : undefined;
    const mockAccount = tokenAccount || account;
    let amount = transaction.useAllAmount
        ? yield estimateMaxSpendable({ account: mockAccount })
        : transaction.amount;
    let totalSpent = transaction.amount.plus(estimatedFees);
    const useAllAmount = Boolean(transaction.useAllAmount);
    let tokensToSend = [];
    if (transaction.subAccountId) {
        // Token transaction
        if (!tokenAccount || tokenAccount.type !== "TokenAccount") {
            throw new Error("TokenAccount not found");
        }
        const { assetId } = (0, buildSubAccounts_1.decodeTokenCurrencyId)(tokenAccount.token.id);
        const { policyId, assetName } = (0, buildSubAccounts_1.decodeTokenAssetId)(assetId);
        amount = transaction.useAllAmount ? tokenAccount.balance : transaction.amount;
        totalSpent = amount;
        tokensToSend = [
            {
                policyId,
                assetName,
                amount,
            },
        ];
    }
    else {
        amount = transaction.useAllAmount ? yield estimateMaxSpendable({ account }) : amount;
        totalSpent = amount.plus(estimatedFees);
    }
    const minTransactionAmount = typhonjs_1.utils.calculateMinUtxoAmount(tokensToSend, new bignumber_js_1.default(account.cardanoResources.protocolParams.lovelacePerUtxoWord), false);
    if (!transaction.fees) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    if (!transaction.recipient) {
        errors.recipient = new errors_1.RecipientRequired();
    }
    else if (!isValidAddress(transaction.recipient)) {
        errors.recipient = new errors_1.InvalidAddress("", {
            currencyName: account.currency.name,
        });
    }
    if (!amount.gt(0)) {
        errors.amount = useAllAmount ? new errors_2.CardanoNotEnoughFunds() : new errors_1.AmountRequired();
    }
    else if (!transaction.subAccountId && amount.lt(minTransactionAmount)) {
        errors.amount = new errors_2.CardanoMinAmountError("", {
            amount: minTransactionAmount.div(1e6).toString(),
        });
    }
    else if (tokenAccount ? totalSpent.gt(tokenAccount.balance) : totalSpent.gt(account.balance)) {
        errors.amount = new errors_1.NotEnoughBalance();
    }
    else {
        try {
            yield (0, js_buildTransaction_1.buildTransaction)(account, transaction);
        }
        catch (e) {
            if (e.message.toLowerCase() === "not enough ada" ||
                e.message.toLowerCase() === "not enough tokens") {
                errors.amount = new errors_2.CardanoNotEnoughFunds();
            }
        }
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
});
const prepareTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    transaction.fees = new bignumber_js_1.default(100);
    return transaction;
});
const accountBridge = {
    createTransaction,
    updateTransaction: jsHelpers_1.defaultUpdateTransaction,
    getTransactionStatus,
    estimateMaxSpendable,
    prepareTransaction,
    sync: mockHelpers_1.sync,
    receive,
    signOperation: mockHelpers_1.signOperation,
    broadcast: mockHelpers_1.broadcast,
};
const currencyBridge = {
    preload: () => Promise.resolve({}),
    hydrate: () => { },
    scanAccounts: mockHelpers_1.scanAccounts,
};
exports.default = {
    accountBridge,
    currencyBridge,
};
//# sourceMappingURL=mock.js.map